module.exports = __webpack_public_path__ + "img/header_cart.4e4cb6a8.svg";